import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IAppSettingConfigModel } from '../../models/app-setting/app-setting.model';

@Injectable({
  providedIn: 'root',
})
export class AppSettingAPIService {
  constructor(private http: HttpClient) {}

  public getAppSettingJSON(): Observable<IAppSettingConfigModel> {
    return this.http.get('./assets/settings/app-settings.json') as Observable<IAppSettingConfigModel>;
  }
}
